import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.map.js";
import React from 'react';
import { Search } from '@finect/tabular-icons/search';
import { Paragraph } from '@finect/tabular-core/Paragraph';
import { H4 } from '@finect/tabular-core/Headings';
import { Loading } from '../../../Loading';
import { UserComparisonLine } from '../UserComparisonLine';
import { Inner, Title, Content, EmptyContentInner } from './partials';
var EmptyContent = function EmptyContent() {
  return React.createElement(EmptyContentInner, null, React.createElement(Search, {
    size: 56
  }), React.createElement(Paragraph, null, "\xA1Vaya! Todav\xEDa no has guardado ninguna comparaci\xF3n de productos"));
};
export var UserComparisons = function UserComparisons(_ref) {
  var userComparisons = _ref.userComparisons,
    onSelect = _ref.onSelect,
    onDelete = _ref.onDelete,
    _ref$withTitle = _ref.withTitle,
    withTitle = _ref$withTitle === void 0 ? false : _ref$withTitle;
  var models = userComparisons.models,
    fetching = userComparisons.fetching,
    fetched = userComparisons.fetched;
  var sessionsToDisplay = models.filter(function (session) {
    return session.status === 'completed';
  }).slice(0, 100);
  if (fetching) {
    return React.createElement(Loading, null);
  }
  return React.createElement(Inner, null, withTitle ? React.createElement(Title, null, React.createElement(H4, null, "Mis comparaciones guardadas")) : null, React.createElement(Content, null, fetched && !sessionsToDisplay.length ? React.createElement(EmptyContent, null) : sessionsToDisplay.map(function (session, index) {
    return React.createElement(UserComparisonLine, {
      key: "session-".concat(index),
      session: session,
      onClick: function onClick(selected) {
        onSelect(selected);
      },
      onDelete: onDelete
    });
  })));
};